import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import TextInput from '../Inputs/TextInput';
import { translate } from 'translations/translator';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import ModalsTranslationVariant from 'translations/variants/modals';
import { ModalPadding } from 'styles/style-constants';
const getTranslation = (key: ModalsTranslationVariant) => translate('modals', key);

type Props = {
  handleRenameTeachingOrder: (teachingOrderId) => void;
};

export const EditTeachingOrderModal: React.FC<Props> = ({ handleRenameTeachingOrder }) => {
  const [name, setName] = React.useState('');
  const [, { closeModal }] = useModal();
  const classes = useStyles();

  const handleRename = () => {
    handleRenameTeachingOrder(name);
    closeModal();
  };

  const handleChange = (key, name) => {
    setName(name);
  };
  return (
    <Container className={`${classes.container} ${classes.spaced}`}>
      <Typography variant="h6" style={{ paddingTop: 24, textAlign: 'center' }}>
        {getTranslation(ModalsTranslationVariant.editTeachingOrderTitle)}
      </Typography>
      <Box>
        <TextInput
          size="medium"
          onChange={handleChange}
          label={getTranslation(ModalsTranslationVariant.editTeachingOrderLabelTitle)}
          variant="outlined"
          className={classes.textInput}
          InputLabelProps={{ classes: { root: classes.font } }}
        ></TextInput>
      </Box>
      <Box display="flex" className={classes.spaced}>
        <HwtButton onClick={closeModal} variant="outlined" className={classes.button}>
          {getTranslation(ModalsTranslationVariant.editTeachingOrderBackToManage)}
        </HwtButton>
        <HwtButton variant="contained" onClick={handleRename} className={classes.button}>
          {getTranslation(ModalsTranslationVariant.editTeachingOrderYesRename)}
        </HwtButton>
      </Box>
    </Container>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex !important',
    flex: 1,
    flexDirection: 'column',
    height: '354px',
    width: '616px !important',
    ...ModalPadding,
    backgroundColor: '#fff'
  },
  button: {
    width: 'max-content !important'
  },
  spaced: {
    justifyContent: 'space-between'
  },
  font: {
    fontSize: '12px'
  },
  textInput: {
    border: 'unset',
    width: '100%',
    marginBottom: '4px'
  }
}));
